import * as React from 'react';
export const mayaSvg = React.forwardRef(function mayaSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#F5F6F8',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M8.181 12.001c-.647 0-1.304.27-1.724.699l.238.473-.1.08c-.445-.762-1.263-1.252-2.134-1.252-1.36 0-2.46 1.183-2.46 2.57v2.985a.183.183 0 0 0 .117.18c.024.009.05.013.075.012h.987a.181.181 0 0 0 .18-.18v-3.02c0-.688.42-1.25 1.134-1.25.67 0 1.145.495 1.145 1.227v2.479a.178.178 0 0 0 .109.177c.023.01.047.014.072.014h.943a.184.184 0 0 0 .132-.056.18.18 0 0 0 .048-.135v-2.479c0-.732.5-1.228 1.168-1.228.715 0 1.112.563 1.112 1.25v3.02a.187.187 0 0 0 .192.18h.975a.186.186 0 0 0 .18-.117.184.184 0 0 0 .013-.075V14.57c0-1.386-1.055-2.569-2.405-2.569m5.845 4.597c-.975 0-1.656-.687-1.656-1.656 0-.98.68-1.68 1.655-1.68.987 0 1.69.7 1.69 1.68 0 .968-.703 1.656-1.69 1.656Zm2.982-4.484h-.897a.183.183 0 0 0-.178.107.178.178 0 0 0-.015.072v.124l.318.496-.086.085c-.524-.591-1.273-.998-2.126-.998a2.94 2.94 0 0 0-2.937 2.94c.002.773.312 1.514.862 2.06.55.548 1.297.856 2.075.858.86 0 1.614-.404 2.138-.995l.072.06-.315.52v.112a.19.19 0 0 0 .194.192h.895a.187.187 0 0 0 .14-.054.184.184 0 0 0 .053-.138v-5.261c0-.113-.08-.18-.193-.18m9.82 4.484c-.974 0-1.656-.687-1.656-1.656 0-.98.68-1.68 1.656-1.68.987 0 1.69.7 1.69 1.68 0 .968-.703 1.656-1.69 1.656Zm2.983-4.484h-.896a.182.182 0 0 0-.178.107.181.181 0 0 0-.015.072v.124l.317.496-.085.085c-.524-.591-1.273-.998-2.126-.998a2.94 2.94 0 0 0-2.937 2.94c.002.773.312 1.514.862 2.06a2.95 2.95 0 0 0 2.075.858c.86 0 1.614-.404 2.138-.995l.072.06-.318.518v.113a.192.192 0 0 0 .056.136.19.19 0 0 0 .137.055h.896a.186.186 0 0 0 .18-.117.177.177 0 0 0 .013-.074v-5.26c0-.113-.08-.18-.193-.18m-6.664.001h-.919c-.147 0-.227.079-.227.157v2.75c0 .856-.567 1.453-1.44 1.453-.805 0-1.327-.597-1.327-1.453v-2.75c0-.078-.124-.157-.204-.157h-.986a.171.171 0 0 0-.16.157v2.739c0 1.464 1.158 2.738 2.677 2.738.687 0 1.35-.25 1.867-.7l.05.046-.408.552v.215c0 .563-.85.879-1.35.879h-.317c-.113 0-.204.079-.204.18v.9c0 .09.09.18.204.18h.318c1.52 0 2.63-.88 2.63-2.535v-5.194c0-.078-.079-.157-.204-.157',
      fill: '#50B16B',
    }),
  );
});
mayaSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var maya = {
  category: 'brand',
  colorable: false,
  name: 'maya',
  svg: mayaSvg,
};
